import { render, staticRenderFns } from "./SinisterMapLayers.vue?vue&type=template&id=6dfdf7f6&scoped=true"
import script from "./SinisterMapLayers.vue?vue&type=script&lang=ts"
export * from "./SinisterMapLayers.vue?vue&type=script&lang=ts"
import style0 from "./SinisterMapLayers.vue?vue&type=style&index=0&id=6dfdf7f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfdf7f6",
  null
  
)

export default component.exports